import { BaseFontSize } from "../../Typography";

export enum IconSizes {
  ExtraSmall = 0.5 * BaseFontSize,
  Small = BaseFontSize,
  Medium = 1.5 * BaseFontSize,
  Large = 2 * BaseFontSize,
  ExtraLarge = 3 * BaseFontSize,
}
